import React from "react";
import { getShorthandName } from "../../../../../utils/Helper";

export const KeyPersonnelItem = ({ keyPersonnel: { key_personnelID } }) => {
  return (
    <tr class="bg-white border-b border-slate text-secondary text-f14">
      <td
        scope="row"
        class="flex items-center px-6 py-4 text-gray-900 whitespace-nowrap "
      >
        {false ? (
          <img
            src={false}
            className="rounded-full w-14 h-14 border-4 border-light"
            alt="user"
          />
        ) : (
          <div className="w-14 h-14 rounded-full flex items-center justify-center border-4 border-lightGray shadow-md cursor-pointer">
            <span
              className={`text-profile ${
                getShorthandName(key_personnelID.name || "").length > 2
                  ? "text-f12"
                  : "text-f14"
              }`}
            >
              {getShorthandName(key_personnelID.name || "")}
            </span>
          </div>
        )}
        <div class="pl-3">
          <div class="text-f14 text-secondary">{key_personnelID.name}</div>
        </div>
      </td>
      {key_personnelID?.designation && (
        <td class="px-6 py-4 ">
          <span
            style={{fontSize: "9.75px"}}
            class={`px-8 py-1 w-40 text-center block ${
              key_personnelID.designation === "CEO"
                ? "bg-CEO/[.2] text-CEO/[.8]"
                : key_personnelID.designation === "CFO"
                ? "bg-CFO/[.2] text-CFO/[.8]"
                : key_personnelID.designation === "COO"
                ? "bg-COO/[.2] text-COO/[.8]"
                : key_personnelID.designation === "CTO"
                ? "bg-CTO/[.2] text-CTO/[.8]"
                : key_personnelID.designation === "CMO"
                ? "bg-CMO/[.2] text-CMO/[.8]"
                : "bg-COO/[.2] text-COO/[.8]"
            } rounded-full text-f14 font-semibold `}
          >
            {key_personnelID.designation}
          </span>
        </td>
      )}
      {key_personnelID?.work_mobile && (
        <td class="px-6 py-4">
          {key_personnelID?.work_mobile?.replace("|", "") || "-"}
        </td>
      )}
      {key_personnelID?.work_email && (
        <td class="px-6 py-4">{key_personnelID?.work_email || "-"}</td>
      )}
    </tr>
  );
};
